import WidgetModule from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";

export * from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";

export default WidgetModule;
